import { TrackingRegion } from '../../../common/AnalyticsContext/TrackingData';
import { ButtonVariants } from '../../../common/components/Button/DeprecatedButtonVariants';
import { StyledLinkButton } from '../../../common/components/Button/StyledButtons';
import { Heading } from '../../../common/components/Typography/Heading/Heading';
import {
  DownloadAppContentContainer,
  DownloadAppPageSection,
  DownloadAppSectionLeftCol,
  DownloadAppSectionPhoneGraphic,
  DownloadAppSectionPhoneGraphicLink,
  DownloadAppSectionRightCol,
  DownloadAppSectionRow,
} from './DownloadAppSection.styles';

export const DownloadAppSection = () => (
  <DownloadAppPageSection trackingRegionId={TrackingRegion.DOWNLOAD_APP}>
    <DownloadAppSectionRow>
      <DownloadAppContentContainer>
        <DownloadAppSectionLeftCol>
          <Heading h2>Healthengine is your home for healthcare.</Heading>
          <Heading h4>Find, book and keep your favourite practitioners in one place.</Heading>
          <StyledLinkButton to="https://he.app.link/DGDq3wzyUgb" variant={ButtonVariants.accent}>
            Download the app
          </StyledLinkButton>
        </DownloadAppSectionLeftCol>
      </DownloadAppContentContainer>
      <DownloadAppSectionRightCol>
        <DownloadAppSectionPhoneGraphicLink href="https://he.app.link/DGDq3wzyUgb">
          <DownloadAppSectionPhoneGraphic
            src="/public/images/download_app_20210808060636.png"
            htmlAttributes={{ alt: 'Phone Graphic' }}
          />
        </DownloadAppSectionPhoneGraphicLink>
      </DownloadAppSectionRightCol>
    </DownloadAppSectionRow>
  </DownloadAppPageSection>
);
